import React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { RECIPIENT_GROUPING_TYPE_OPTIONS } from 'constants/systemProcesses'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const AssigneeContainer = styled.div`
  display: flex;
  gap: 12px;

  > :first-child {
    flex: 0.5;
  }

  > :last-child {
    flex: 1;
  }
`

const ActionDataContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: end;

  > div {
    flex: 1;
  }
`

interface Props {
  field: string
}

const Action: React.FC<Props> = ({ field }) => {
  return (
    <Container>
      <AssigneeContainer>
        <ReduxSelect name={`${field}.actionToType`} options={RECIPIENT_GROUPING_TYPE_OPTIONS} />
        <ReduxSelect name={`${field}.actionTo`} options={[{ label: 'Owner of parent', value: null }]} />
      </AssigneeContainer>
      <ReduxInput label='Description' name={`${field}.actionDescription`} />
      <ActionDataContainer>
        <ReduxSelect name={`${field}.actionField`} options={[{ label: 'Due Date', value: null }]} />
        <ReduxInput name={`${field}.actionDays`} type='number' />
        days
      </ActionDataContainer>
    </Container>
  )
}

export default Action
